import type { PageLoad } from './$types';
import { routesPagename } from '$lib/services/urls/routesPagename';

export const load = (async () => {
	return {
		pagename: routesPagename.ROUTE_EXPENSE_EDIT,
	};
}) satisfies PageLoad;
